import React from 'react';
import { Modal } from 'framework/ui/ui-builder';
import RuleForm from './RuleForm';
import { RuleValidationResult, TargetRule } from '../types';
import { Button } from 'framework/ui/mui-builder';
import type { Technology } from 'domain/shared/career';
import { PositionType } from 'domain/shared/employee';

interface EditRuleDialogProps {
  open: boolean;
  onClose: () => void;
  rule: Omit<TargetRule, 'id'>;
  onSave: (updatedRule: Omit<TargetRule, 'id'>) => void;
  validation: RuleValidationResult;
  onChange: (field: string, value: any) => void;
  positions: PositionType[];
  technologies: Technology[];
}

const EditRuleDialog: React.FC<EditRuleDialogProps> = ({
  open,
  onClose,
  rule,
  onSave,
  validation,
  onChange,
  positions,
  technologies,
}) => {
  if (!open) return null;

  return (
    <Modal
      isOpen={open}
      onToggle={onClose}
      title="Edit rule"
      hasCancelButton
      buttons={
        <Button
          onClick={() => onSave(rule)}
          color="primary"
          variant="contained"
          disabled={!validation.valid}
          data-testid="rule-form-submit-button"
        >
          Save Changes
        </Button>
      }
    >
      <RuleForm
        rule={rule}
        validation={validation}
        onChange={onChange}
        positions={positions}
        technologies={technologies}
        showSubmitButton={false}
        isInDialog
      />
    </Modal>
  );
};

export default EditRuleDialog;
